exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact-left-margin[data-v-053946d6]{margin-left:140px\n}\n.text-grey[data-v-053946d6]{color:#898185\n}\n", ""]);

// exports
